import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { ModalContents } from './ModalContents';

interface ManagerListModalProps {
  closeManagerListModal: () => void;
  managerData: any[];
  managerEmployeeNum: string;
  setManagerEmployeeNum: Dispatch<SetStateAction<string>>;
  managerName: string;
  setManagerName: Dispatch<SetStateAction<string>>;
}

export const ManagerListModal = ({
  closeManagerListModal,
  managerData,
  managerEmployeeNum,
  setManagerEmployeeNum,
  managerName,
  setManagerName,
}: ManagerListModalProps) => {
  return (
    <Background onClick={closeManagerListModal}>
      <Container
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <ModalContents
          closeManagerListModal={closeManagerListModal}
          managerData={managerData}
          managerEmployeeNum={managerEmployeeNum}
          setManagerEmployeeNum={setManagerEmployeeNum}
          managerName={managerName}
          setManagerName={setManagerName}
        />
      </Container>
    </Background>
  );
};

const Background = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* rgba(0, 0, 0, 0.3) */
  z-index: 999;
`;

const Container = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: white;
`;
